<div id="maintenance-wrapper">
  <bw-action-article-legacy [brightsideWebFb]="{ event_name: 'app_maintenance' }">
    <div pre-title>
      <img class="mb-sm" src="../assets/maintenance-pig.png" />
    </div>
    <div header-title>
      <typography-legacy title-large color="var(--primary-text)">
        {{ 'APP_MAINTENANCE_TITLE' | translate }}
      </typography-legacy>
    </div>
    <div content-section>
      <bw-paragraph-legacy>{{ 'APP_MAINTENANCE_DESC' | translate }}</bw-paragraph-legacy>
    </div>
  </bw-action-article-legacy>
</div>
